import Vue from "vue";
import Vuetify from "vuetify/lib";
import "material-design-icons-iconfont/dist/material-design-icons.css";
Vue.use(Vuetify);
// Helpers
import colors from "vuetify/es5/util/colors";
export default new Vuetify({
  icons: {
    iconfont: "md",
  },
  theme: {
    themes: {
      light: {
        primary: "#003068",
        secondary: "#b0bec5",
        accent: "#002f6c",
      },
    },
  },
});
